"use strict";

var _debounce = _interopRequireDefault(require("lodash-es/debounce"));

var _themeSections = require("@shopify/theme-sections");

var _cssClasses = _interopRequireDefault(require("../helpers/cssClasses"));

var _utils = require("../helpers/utils");

var _toggle = _interopRequireDefault(require("../components/toggle"));

var _notification = _interopRequireDefault(require("../components/notification"));

var _scrollDirection = _interopRequireDefault(require("../mixins/scroll-direction"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Section: Site header
 * ------------------------------------------------------------------------------
 * Contains highly coupled scripts to control site header components
 *
 * @namespace siteHeader
 */

/**
 * DOM selectors.
 */


var selectors = {
  container: '[js-site-header="container"]'
};
/**
 * Create a new site header object.
 */

(0, _themeSections.register)('site-header', {
  /**
   * Callback function when the section is loaded in via the 'sections.load()' function or by Theme Editor
   * 'shopify:section:unload' event
   */
  onLoad: function onLoad() {
    this.constructComponents();
    this.init();
  },

  /**
   * Component selectors.
   */
  setNodeSelectors: function setNodeSelectors() {
    this.container = document.querySelector(selectors.container);
  },

  /**
   * Instantiate search bar toggle.
   */
  constructSearchToggle: function constructSearchToggle() {
    this.SearchBar = (0, _toggle["default"])({
      toggleSelector: 'searchToggle',
      targetSelector: 'searchTarget' // overlay: false,

    });
  },

  /**
   * Instantiate announcement component.
   */
  constructAnnouncement: function constructAnnouncement() {
    this.Announcement = (0, _notification["default"])({
      container: '.site-header__announcement',
      enableCookies: true,
      cookie: {
        namespace: 'frame_announcement',
        value: 'dismissed'
      }
    });
  },

  /**
   * Instantiate a collapsed header on scroll using scrollDirection helper.
   */
  constructStickyHeader: function constructStickyHeader() {
    this.AnimatedHeader = (0, _scrollDirection["default"])({
      throttle: 250,
      start: 100
    });
  },

  /**
   * Construct section components.
   */
  constructComponents: function constructComponents() {
    this.constructSearchToggle();
    this.constructAnnouncement();
    this.constructStickyHeader();
  },

  /**
   * Initialise component.
   */
  init: function init() {
    this.setNodeSelectors();
    this.Announcement.init();
    this.setScrollEvents();
    this.setStickyHeader();
    this.setSearchToggle();
  },

  /**
   * Set search toggle events.
   */
  setSearchToggle: function setSearchToggle() {
    this.SearchBar.init();
  },

  /**
   * Set sticky header events after document has loaded styling.
   */
  setStickyHeader: function setStickyHeader() {
    var _this = this;

    (0, _utils.on)('load', function () {
      _this.AnimatedHeader.init();

      _this.container.parentNode.classList.add(_cssClasses["default"].sticky);

      _this.updateBodyOffset();

      (0, _utils.on)('resize', (0, _debounce["default"])(function () {
        return _this.handleResizeEvents();
      }, 250));
    });
  },

  /**
   * Handle resize events by requesting animation frame.
   */
  handleResizeEvents: function handleResizeEvents() {
    this.updateBodyOffset();
  },

  /**
   * Re-paint body padding-top using current header height.
   */
  updateBodyOffset: function updateBodyOffset() {
    document.body.style.paddingTop = "".concat(this.container.parentNode.offsetHeight, "px");
  },

  /**
   * Set listeners based on scroll direction.
   */
  setListeners: function setListeners() {
    var _this2 = this;

    Frame.EventBus.listen('Notification:dismissed', function () {
      _this2.updateBodyOffset();
    });
    Frame.EventBus.listen('ScrollDirection:down', function () {
      _this2.container.parentNode.classList.add(_cssClasses["default"].collapsed);
    });
    Frame.EventBus.listen('ScrollDirection:top', function () {
      _this2.container.parentNode.classList.remove(_cssClasses["default"].collapsed);
    });
    Frame.EventBus.listen('Toggle:searchTarget:open', function () {
      document.documentElement.classList.add('js-search-active');
    });
    Frame.EventBus.listen('Toggle:searchTarget:close', function () {
      document.documentElement.classList.remove('js-search-active');
    });
  },

  /**
   * Set scroll events.
   */
  setScrollEvents: function setScrollEvents() {
    this.setListeners();
  }
});